<template>
  <div
    :class="classes"
    class="bracket-final-participant"
    @click="showTeamRoster"
  >
    <template v-if="participant">
      <span class="bracket-final-participant__name">{{
        participant.name
      }}</span>
    </template>

    <span v-else class="bracket-final-participant__name"></span>

    <div v-if="!result" class="bracket-final-participant__score">
      {{ participant && score }}
    </div>
  </div>
</template>

<script>
import { openModal } from "@/components/teams/TeamView";
import service from "@/services/team";

export default {
  name: "BracketFinalParticipant",
  props: {
    result: Boolean,
    participant: {
      type: Object
    },
    score: {
      type: [String, Number]
    }
  },
  data: () => ({
    loading: false
  }),
  computed: {
    classes() {
      return {
        "is-valid-team": this.isValidTeam
      };
    },
    isValidTeam() {
      return this.participant && this.participant.id && !this.participant.fake;
    }
  },
  methods: {
    async showTeamRoster() {
      const { participant } = this;
      if (!this.isValidTeam || this.loading) return;
      this.loading = true;
      const { data, success } = await service.getTeamDetails(participant.id);
      if (success) {
        openModal(data);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
$border-color: colors(palette-2);
$p: ".bracket-final-participant";

.bracket-final-participant {
  height: 35px;
  border-radius: 3px;
  background-color: currentColor;
  margin: auto 0;
  display: flex;
  align-items: center;
  position: relative;
  padding-right: 50px;

  &.is-valid-team {
    cursor: pointer;
  }

  &:not(:last-child) {
    margin-bottom: 4px;
  }

  &:first-child {
    color: colors(palette-4);
  }
  &:nth-child(2) {
    color: colors(palette-2);
  }

  &__score {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 2px;
    top: 2px;
    bottom: 2px;
    width: 31px;
    background-color: colors(palette-1);
    font-size: 24px;
    font-weight: fw(bold);
    border-radius: 3px;
    color: colors(text-2);
  }

  &__name {
    font-size: 18px;
    font-weight: fw(bold);
    @include text-ellipsis();
    max-width: 100%;
    color: colors(text-3);
    padding-right: 10px;
    text-transform: uppercase;
    padding-left: 20px;
  }

  &__img-container {
    margin-right: 10px;
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    background-color: #aabbd0;
  }

  &__img {
    width: 100%;
    height: 100%;
  }
}
</style>
